<template>
  <BoostRewards v-if="isBoostRewards" />
  <OrdersTable v-else />
</template>

<script setup lang="ts">
import BoostRewards from '@/components/merchant/orders/boost-rewards/BoostRewards.vue';
import OrdersTable from '@/components/merchant/orders/orders-table/OrdersTable.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const isBoostRewards = computed(() => {
  return route.query.type === 'BoostRewards';
});
</script>
